<template>
  <span>
    <slot
      name="default"
      :amount="currentAmount"
      v-if="currentAmount > 0 || !slots.null"
    >
      <slot
        name="converted-currency"
        :amount="currentAmount"
        :currency="currency"
      >
        {{ formatedCurrentAmount }}
      </slot>

      <app-tooltip
        class="d-inline-block"
        v-if="isConverted"
      >
        <i
          class="default italic color--lg cursor--help"
          :aria-describedby="`default_amount_tooltip${id}`"
        >
          (
          <slot
            name="default-currency"
            :amount="defaultAmount"
            :currency="defaultCurrency"
          >
            {{ formartedDefaultAmount }}
          </slot>
          )
        </i>

        <template #popper>
          <div
            :id="`default_amount_tooltip${id}`"
            role="tooltip"
          >
            <slot name="tooltip">
              {{ t('literal.amount_in_default_currency') }}
            </slot>
          </div>
        </template>
      </app-tooltip>
    </slot>

    <slot
      name="null"
      :amount="currentAmount"
      v-else
    />
  </span>
</template>

<script setup>
import { computed, defineAsyncComponent, useSlots } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useMoney } from '@/composables/app/useMoney'
import { guid } from '@/utils/utils'

const AppTooltip = defineAsyncComponent(() => import('&/atoms/AppTooltip'))

const { amount, currency, defaultCurrency, showCurrency } = defineProps({
  amount: { type: [Number, Object], required: true },
  currency: { type: String },
  defaultCurrency: { type: String },
  showCurrency: { type: Boolean, default: true }
})

const slots = useSlots()
const { t } = useI18n()
const { getAmount, getFormatedAmount, isConvertedAmount } = useMoney()

const id = `amount${guid(1)}`

const currentAmount = computed(() => getAmount({ amount, currency }))
const defaultAmount = computed(() => getAmount({ amount, currency: defaultCurrency }))
const isConverted = computed(() => isConvertedAmount({ amount, currency }) && defaultAmount.value && defaultCurrency && defaultCurrency !== currency)

const formatedCurrentAmount = computed(() => getFormatedAmount({ amount, currency, showCurrency }))
const formartedDefaultAmount = computed(() => getFormatedAmount({ amount, currency: defaultCurrency, showCurrency }))
</script>
